import React from 'react';
import { Label } from 'semantic-ui-react';
import { RECOMMENDATION_TIER_LABELS } from '../constants';

const TierLabel = ({ tier, size = 'tiny' }) => {
    const tierLabel = RECOMMENDATION_TIER_LABELS[tier];
    if (!tierLabel) {
        return null;
    }
    return <Label size={size} basic color={tierLabel.color}>{tierLabel.text}</Label>;
}

export default TierLabel;
